import axiosInstance from "../../utils/axiosInstance";
import {
  setErrorLoadingProductCategories,
  setLoadingProductCategories,
  setProductCategories,
} from "../slices/category";
import { toast } from "react-toastify";

export const getProductCategories = () => async (dispatch) => {
  dispatch(setLoadingProductCategories());
  try {
    const { data } = await axiosInstance.get("/product-categories");
    if (data.status === "SUCCESS") {
      dispatch(setProductCategories(data.data));
    }
  } catch (error) {
    dispatch(
      setErrorLoadingProductCategories(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An expected error has occured. Please try again later."
      )
    );
  }
};
